import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { styled } from 'styled-components';
import { SkapaSkeleton } from '@inter-ikea-guida/skapa';
import { fadeInKeyframes } from '../style';
const StyledImage = styled.img `
  width: 100%;
  cursor: pointer;

  display: ${props => (props.$imageLoaded ? 'block' : 'none')};

  aspect-ratio: ${props => props.$aspectRatio ?? 'unset'};
  pointer-events: none;
  object-fit: cover;
  object-position: ${props => props.$position};

  opacity: ${props => props.$opacity};
`;
const StyledSkeletonWrapper = styled.div `
  aspect-ratio: ${props => props.$aspectRatio ?? 'unset'};
  animation: ${fadeInKeyframes} ${props => (props.$animateSkeleton ? '0.5s' : 0)} ease-in;
`;
const StyledImageWrapper = styled.div `
  border-radius: ${props => props.$borderRadius ?? 0};
  overflow: ${props => (props.$borderRadius ? 'hidden' : 'unset')};
`;
export const GuidaImage = ({ loading, alt = '', src, onLoad, enableSkeleton, aspectRatio, borderRadius, className, animateSkeleton = true, position = 'center', opacity = 1 }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const isExternalLoading = loading !== undefined;
    const isLoading = isExternalLoading ? loading || !imageLoaded : !imageLoaded;
    return (_jsxs(StyledImageWrapper, { className: className, "$borderRadius": borderRadius, children: [_jsx(StyledImage, { "$aspectRatio": aspectRatio, "$imageLoaded": !isLoading, "$position": position, src: src, alt: alt, "$opacity": opacity, onLoad: () => {
                    setImageLoaded(true);
                    if (onLoad) {
                        onLoad();
                    }
                } }), isLoading && enableSkeleton && (_jsx(StyledSkeletonWrapper, { "$aspectRatio": aspectRatio, "$animateSkeleton": animateSkeleton, children: _jsx(SkapaSkeleton, { dataTestId: 'guida-image-skeleton', height: '100%', width: '100%' }) }))] }));
};
//# sourceMappingURL=GuidaImage.js.map